import styled from 'styled-components';

const MOD_PADDING = '24px';

export const ModalFooterS = styled.footer`
  padding: 16px ${MOD_PADDING};
`;
export const ModalBodyS = styled.div`
  text-align: justify;
  padding: 0 ${MOD_PADDING} 32px;
  overflow: auto;
  flex: 1;
  /* max-height: 56vh; */
  hr {
    opacity: 0.12;
  }

  .btn-add {
    margin-top: 20px;
  }

  h3 {
    font-size: 1.6rem;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    color: #3c3c3c;
  }
`;
export const BtnsWrapperS = styled.footer`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  button {
    width: auto;
    margin-left: 16px;

    &:first-child {
      margin-left: 0;
    }
  }
`;

export const ModalBodyTextS = styled.p`
  font-size: 1.6rem;
`;

export const WrapBtn = styled.div`
  display: flex;
  justify-content: center;
  & > * {
    &:nth-child(1) {
      margin-right: 50px;
    }
  }
`;

export const WrapText = styled.h4`
  img {
    width: 50px;
    height: auto;
  }
`;

export const HeadingS = styled.h2`
  margin: 0 auto 20px auto;
  width: 700px;
`;

export const WrapMessage = styled.div`
  text-align: justify;
  margin: auto;
  width: 700px;
  margin-bottom: 45px;
  h3 {
    display: inline;
    margin-right: 10px;
  }
`;

export const WrapForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
`;
